<div class="skeleton">
  <ngx-skeleton-loader
    [appearance]="data?.appearance ?? 'line'"
    [theme]="data?.theme"
    [count]="data?.rows ?? 1"
  ></ngx-skeleton-loader>
</div>
